// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ImportProjectItemsModalMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ImportProjectItemsModalMetadataQuery = { __typename?: 'Query', unitsOfMeasure: Array<{ __typename?: 'UnitOfMeasure', id: string, name: string, abbreviation: string, sageName?: string | null | undefined }>, locations: Array<{ __typename?: 'Location', id: string, name: string }>, items: Array<{ __typename?: 'Item', id: string, fullCode: string, isSelection: boolean, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string } }> };

export type ImportProjectItemsModalMetadata_UnitOfMeasureFragment = { __typename?: 'UnitOfMeasure', id: string, name: string, abbreviation: string, sageName?: string | null | undefined };

export type ImportProjectItemsModalMetadata_ItemFragment = { __typename?: 'Item', id: string, fullCode: string, isSelection: boolean, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string } };

export const ImportProjectItemsModalMetadata_UnitOfMeasureFragmentDoc = gql`
    fragment ImportProjectItemsModalMetadata_UnitOfMeasure on UnitOfMeasure {
  id
  name
  abbreviation
  sageName
}
    `;
export const ImportProjectItemsModalMetadata_ItemFragmentDoc = gql`
    fragment ImportProjectItemsModalMetadata_Item on Item {
  id
  fullCode
  isSelection
  unitOfMeasure {
    id
    name
  }
}
    `;
export const ImportProjectItemsModalMetadataDocument = gql`
    query ImportProjectItemsModalMetadata {
  unitsOfMeasure {
    ...ImportProjectItemsModalMetadata_UnitOfMeasure
  }
  locations {
    ...Named
  }
  items {
    ...ImportProjectItemsModalMetadata_Item
  }
}
    ${ImportProjectItemsModalMetadata_UnitOfMeasureFragmentDoc}
${NamedFragmentDoc}
${ImportProjectItemsModalMetadata_ItemFragmentDoc}`;

/**
 * __useImportProjectItemsModalMetadataQuery__
 *
 * To run a query within a React component, call `useImportProjectItemsModalMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportProjectItemsModalMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportProjectItemsModalMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useImportProjectItemsModalMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ImportProjectItemsModalMetadataQuery, ImportProjectItemsModalMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ImportProjectItemsModalMetadataQuery, ImportProjectItemsModalMetadataQueryVariables>(ImportProjectItemsModalMetadataDocument, options);
      }
export function useImportProjectItemsModalMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ImportProjectItemsModalMetadataQuery, ImportProjectItemsModalMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ImportProjectItemsModalMetadataQuery, ImportProjectItemsModalMetadataQueryVariables>(ImportProjectItemsModalMetadataDocument, options);
        }
// @ts-ignore
export function useImportProjectItemsModalMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ImportProjectItemsModalMetadataQuery, ImportProjectItemsModalMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ImportProjectItemsModalMetadataQuery, ImportProjectItemsModalMetadataQueryVariables>;
export function useImportProjectItemsModalMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ImportProjectItemsModalMetadataQuery, ImportProjectItemsModalMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ImportProjectItemsModalMetadataQuery | undefined, ImportProjectItemsModalMetadataQueryVariables>;
export function useImportProjectItemsModalMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ImportProjectItemsModalMetadataQuery, ImportProjectItemsModalMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ImportProjectItemsModalMetadataQuery, ImportProjectItemsModalMetadataQueryVariables>(ImportProjectItemsModalMetadataDocument, options);
        }
export type ImportProjectItemsModalMetadataQueryHookResult = ReturnType<typeof useImportProjectItemsModalMetadataQuery>;
export type ImportProjectItemsModalMetadataLazyQueryHookResult = ReturnType<typeof useImportProjectItemsModalMetadataLazyQuery>;
export type ImportProjectItemsModalMetadataSuspenseQueryHookResult = ReturnType<typeof useImportProjectItemsModalMetadataSuspenseQuery>;
export type ImportProjectItemsModalMetadataQueryResult = Apollo.QueryResult<ImportProjectItemsModalMetadataQuery, ImportProjectItemsModalMetadataQueryVariables>;